import React from 'react';
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Typography from "@mui/material/Typography";

/**
 * Format number as currency
 */
const formatCurrency = (value) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(value || 0);
};

/**
 * Big summary card for main metrics
 */
const BigCard = ({label, value, color = 'textPrimary', subtitle}) => (
  <Card sx={{p: 3, flex: 1, minWidth: 280}}>
    <Typography variant="overline" color="textSecondary" sx={{fontSize: '12px'}}>
      {label}
    </Typography>
    <Typography variant="h4" color={color} sx={{fontWeight: 700, mt: 0.5}}>
      {formatCurrency(value)}
    </Typography>
    {subtitle && (
      <Typography variant="body2" color="textSecondary" sx={{mt: 0.5}}>
        {subtitle}
      </Typography>
    )}
  </Card>
);

/**
 * Small summary card for secondary metrics
 */
const SmallCard = ({label, value, color = 'textPrimary', subtitle}) => (
  <Card sx={{p: 2, flex: 1, minWidth: 160}}>
    <Typography variant="overline" color="textSecondary" sx={{fontSize: '10px'}}>
      {label}
    </Typography>
    <Typography variant="h6" color={color} sx={{fontWeight: 600}}>
      {formatCurrency(value)}
    </Typography>
    {subtitle && (
      <Typography variant="caption" color="textSecondary">
        {subtitle}
      </Typography>
    )}
  </Card>
);

/**
 * Summary cards showing totals for cashflow
 */
const CashflowSummary = ({totals = {}, summary = {}}) => {
  return (
    <Box sx={{mt: 3}}>
      <Box sx={{display: 'flex', gap: 2, mb: 2, flexWrap: 'wrap'}}>
        <BigCard
          label="Total Sales (Out)"
          value={totals.sales}
          color="warning.main"
          subtitle={`${totals.loans_count || 0} loans issued`}
        />
        <BigCard
          label="Total Income"
          value={totals.income}
          color="success.main"
          subtitle={`${totals.paid_count || 0} paid, ${totals.waiting_count || 0} waiting`}
        />
      </Box>

      <Box sx={{display: 'flex', gap: 2, flexWrap: 'wrap'}}>
        <BigCard
          label="In Play (Waiting)"
          value={summary.inPlay}
          color="secondary.main"
        />
        <BigCard
          label="Final Cashflow"
          value={totals.cumulative}
          color={totals.cumulative >= 0 ? 'primary.main' : 'error.main'}
        />
      </Box>
    </Box>
  );
};

export default CashflowSummary;